import {_, moment} from "../../../../../vendor";
import t from "../../../helpers/t";
import {Biscuit} from "../../../../utils";
import InvoicesListItem from "./InvoicesListItem";
import React, {useEffect, useState} from "react";
import {currencyFormat, dateFormat, timeFormat} from "../../../../utils/FormatHelper";

const Invoice = (props) => {
    const {
        invoice,
        index,
        dispatch,
        setFilter,
        filter,
        setNKey,
        sort,
        setSort,
        _key,
        filterChangedHandle,
        showNotification,
        currentUrl,
        params,checkedItems,onCheckBox,_readFile,withActions
    } = props;
    let language = Biscuit.get('user.lang').replace('-','_');
    const searchParams = currentUrl.searchParams;



    useEffect(()=>{
        fillData();
    },[]);

    const onItemClickedHandler = (value) => {
         _readFile(value);
    }

    const systems = {
        fp: 'Freizeitplan',
        ib: "Inbooma 2"
    };
    let invoiceData = null;
    const fillData = () => {
        invoiceData = null;
        let inv = invoice;
        let hasInvoiceItems = typeof inv.extern_invoices_positions !== 'undefined' && inv.extern_invoices_positions !== null && inv.extern_invoices_positions.length > 0;
        let toggle = false;
        if (typeof searchParams.get("item") !== 'undefined' && searchParams.get("item") !== null && Number(inv.id) === Number(searchParams.get("item"))) {
            toggle = true;
        }
        //let showInfoIcon = false, showInfoIconIn = false, showInfoIconEx = false, infoTextEx = "", showInfoColor = false;


        let addClasses = '';
        if (inv.paymentStatus === 'Unbezahlt') {
            addClasses += ' red-marked';
        }

        if (toggle) {
            addClasses += ' toggled';
        }
        let elements = [];

        if(withActions){
            elements.push({
                type: "checkBox",
                value: "",
                title: t('selection', null, 'capital'),
                data: {
                    name: invoice.id,
                    onChange: onCheckBox,
                    value: (checkedItems !== {} && typeof checkedItems[invoice.id] !== undefined && checkedItems[invoice.id]),
                    checkBoxLabel: false,
                    switchStyle: {}

                },
                largeWidth: 1,
                mediumWidth: 1,
                smallWidth: 1,
                extraTopClasses: 'show-for-large show-label',
                style: {minWidth: "170px", paddingRight: "2.5%"}
            });
        }
        console.log(invoice,'invoice')
        let newElem = {
            type: "text",
            value: "date",
            title: t('invoice date', null, ''),
            extraClasses: "inb-invoice-date show-label",
            data: [{
                value: "invoiceDate",
                text: moment(invoice.invoiceDate).format(dateFormat(language, true)),
                extraClasses: "inb-order-date__start inb-order-big newline show-label",
                title: t('invoice', null, 'capital') + ' ' + t('invoice date', null, '') + ' ' + moment(invoice.invoiceDate).format(dateFormat(language, true))
            },{
                value: "system",
                text: systems[invoice.system],
                extraClasses: "",
                title: ""
            }],
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: ""
        };
        elements.push(newElem);
        //console.log(newElem,'invoice')
        elements.push({
            type: "text",
            value: "",
            title: t('invoiceNbr', null, 'capital'),
            extraTopClasses: "show-label",
            data: [{
                value: "invoiceNbr",
                text: inv.invoiceNbr,
                extraClasses: "newline show-label",
                title: t('invoiceNbr', null, 'capital')
            }],
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12
        });
        elements.push({
            type: "text",
            value: "",
            title: t('brutto', null, 'capital'),
            extraTopClasses: "show-label",
            data: [{
                value: "amountBrutto",
                text: inv.amountBrutto > 0?currencyFormat(inv.amountBrutto)+"€":currencyFormat(0)+"€",
                extraClasses: "text-small show-label",
                title: t('brutto', null, 'capital')
            }],
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12
        });
        elements.push({
            type: "text",
            value: "",
            title: t('paymentMethod', null, 'capital'),
            extraTopClasses: "show-label",
            data: [{
                value: "paymentMethod",
                text: inv.paymentMethod,
                extraClasses: "text-small show-label",
                title: t('paymentMethod', null, 'capital')
            }],
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12
        });
        elements.push({
            type: "text",
            value: inv.paymentStatus,
            title: t('paymentStatus'),
            data: [
                {
                    value: "paymentStatus",
                    text: t(inv.paymentStatus),
                    extraClasses: "show-label",
                    title: ""
                }
            ],
            extraClasses: "text-small word-break-all show-label",
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "show-label",
        });
        elements.push({
            type: "text",
            value: inv.paymentDate,
            title: t('paymentDate'),
            data: [
                {
                    value: "paymentDate",
                    text: inv.paymentDate !== null ? moment(inv.paymentDate).format(dateFormat(language, false)) : "",
                    extraClasses: "",
                    title: ""
                }
            ],
            extraClasses: "text-small word-break-all show-label",
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "show-label"
        });
        elements.push({
            type: "text",
            value: inv.dueDate,
            title: t('dueDate'),
            data: [
                {
                    value: "dueDate",
                    text: inv.dueDate !== null ? moment(inv.dueDate).format(dateFormat(language, false)) : "",
                    extraClasses: "",
                    title: ""
                }
            ],
            extraClasses: "text-small word-break-all show-label",
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "show-label"
        });
        elements.push({
            type: "text",
            value: inv.warningLevel,
            title: t('paymentStatus'),
            data: [
                {
                    value: "warningLevel",
                    text: inv.warningLevel+"",
                    extraClasses: "",
                    title: ""
                }
            ],
            extraClasses: "text-small word-break-all show-label",
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "show-label"
        });
        elements.push({
            type: "text",
            value: inv.mwst,
            title: t('mwst'),
            data: [
                {
                    value: "mwst",
                    text: inv.mwst + '%',
                    extraClasses: "show-label",
                    title: t('mwst')
                }
            ],
            extraClasses: "text-small word-break-all show-label",
            largeWidth: 1,
            mediumWidth: 12,
            smallWidth: 12,
            extraTopClasses: "show-label"
        });
        elements.push({
                type: "text",
                value: inv,
                title: t('download'),
                extraTopClasses: "text-small show-label",
                data: [{
                    value: inv,
                    text: "",
                    icon: "fi fi-page",
                    ref: "#",
                    title: inv.file,
                    handler: onItemClickedHandler
                }],
                mediumWidth: 1,
                smallWidth: 1,
                handler: onItemClickedHandler
            });


        /* if(hasCheckIn) {
             elements.push({
                 type: "bar",
                 value: "state",
                 title: "",
                 data: [{
                     value: "state",
                     text: getState(reserv),
                     extraClasses: getStateClasses(reserv),
                     extra: (reserv.checkins[0].checkout !== null ? 'has-checkout' : ""),
                     title: ""
                 }],
                 mediumWidth: 12,
                 smallWidth: 12,
                 handler: onItemClickedHandler
             });
         }*/
        /* if (reserv.status !== 'cancelled') {
             elements.push({
                 type: "button",
                 value: (typeof reserv.checkins === 'undefined' || reserv.checkins.length === 0) ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital'),
                 title: (typeof reserv.checkins === 'undefined' || reserv.checkins.length === 0) ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital'),
                 extraTopClasses: "inb-reservation__pdf2",
                 data: [{
                     value: reserv.id,
                     icon: "inb-fi-checkin",
                     extraClasses: "inb-round-btn hollow round float-left",
                     ref: "/reservationsList/" + reserv.id + "/checkin",
                     round: true
                 }],
                 mediumWidth: 1,
                 smallWidth: 1
             });
         }*/


        if (elements !== []) {

            /* console.log({
                 reservation: reserv,
                 hasCompletedCheckouts: hasCompletedCheckouts,
                 hasFutureCheckout: hasFutureCheckout,
                 hasFutureCheckin: hasFutureCheckin
             });*/

            invoiceData = {
                elements: elements,
                addClasses: addClasses,
                hasInvoiceItems: hasInvoiceItems
            };
        }
    }

    fillData();
       /* let reservationMenu =  [
            rbac.hasPermission('edit') && {
                text: t('edit_${a}', {a: t('order', null, 'capital')}),
                href: "/orders/" + reservationLocal.order_id + "/edit" + currentUrl.search,
                iconClass: "fi fi-wrench",
                title: "edit"
            },
            rbac.hasPermission('edit') && {
                text: t('add_payment', null, 'capital'),
                href: "/orders/" + reservationLocal.order_id + "/addpaymentfromreservations" + currentUrl.search,
                iconClass: "fi fi-dollar",
                title: "payments"
            },
            rbac.hasPermission('log') && {
                text: t('show log'),
                href: "#",
                clickHandler: onShowLog,
                reservation: reservationLocal,
                getItem: "reservation",
                iconClass: "fi fi-wrench",
                title: "log"
            }
        ];*/
       /*  if(Biscuit.get('user.is_superuser')  === 'true'){
        reservationMenu.push({
            text: t('changelog', null, 'capital'),
            href: "#",
            clickHandler: openChangeLog,
            changeLog: reservation.changeLogs,
            iconClass: "fi fi-wrench",
            title: "changelog"
        });
    }*/

            /*let reservationMenu = [

                rbac.hasPermission('edit') && {
                    text: t('edit_${a}', {a: t('order', null, 'capital')}),
                    href: "/orders/" + reservationLocal.order_id + "/edit" + currentUrl.search,
                    iconClass: "fi fi-wrench",
                    title: "edit"
                },
                rbac.hasPermission('edit') && {
                    text: t('add_payment', null, 'capital'),
                    href: "/orders/" + reservationLocal.order_id + "/addpaymentfromreservations" + currentUrl.search,
                    iconClass: "fi fi-dollar",
                    title: "payments"
                },
                rbac.hasPermission('log') && {
                    text: t('show log'),
                    href: "#",
                    clickHandler: onShowLog,
                    reservation: reservationLocal,
                    getItem: "reservation",
                    iconClass: "fi fi-wrench",
                    title: "log"
                }
                ] ;*/

            /*if(Biscuit.get('user.is_superuser')  === 'true'){
                reservationMenu.push({
                    text: t('changelog', null, 'capital'),
                    href: "#",
                    clickHandler: openChangeLog,
                    changeLog: reservation.changeLogs,
                    iconClass: "fi fi-wrench",
                    title: "changelog"
                });
            }*/
            return (
                <>
                    {invoiceData !== null && <InvoicesListItem
                        key={"wti-" + index}
                        _key={"wti-" + index}
                        listStyle="checkbox-tight"
                        id={"invoices-item-" + invoice.id}
                        overwriteClasses={"inb-c-item inb-c-item--order inb-c-item-reservation row" + invoiceData.addClasses}
                        elements={invoiceData.elements}
                        invoiceId={invoice.id}
                        invoice={invoice}
                        dispatch={dispatch}
                        length={invoice.extern_invoices_positions.length}
                        app_user_role={Biscuit.get('user.role')}
                        setFilter={setFilter}
                        filter={filter}
                        setNKey={setNKey}
                        sort={sort}
                        setSort={setSort}
                        menu={
                           []
                        }
                    />
                    }
                </>
            );

}
export default Invoice;